import React from 'react';
import fetch from 'isomorphic-fetch';

/**
 * API组件
 */
export default class Api extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      value: "", 
      data: `## API结果显示`,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

   handleChange(event) { 
     this.setState({value: event.target.value}); 
   }

  handleSubmit(event) { 
    event.preventDefault(); 
    fetch(`/api/${this.state.value}`) 
      .then(
        response => response.json(),
        error    => console.log("系统出错：", error)
      ) 
      .then(function(json){
        this.setState({data: json});
      }) 
  }

  render() {
    return ( 
      <div>
      <form onSubmit={this.handleSubmit}> 
        <label>API URL
          <input 
            type="text" 
            value={this.state.value} 
            onChange={this.handleChange} 
            className="form-control" 
            id="basic-url" 
            aria-describedby="basic-addon3" />
        </label> 
        <input type="submit" value="Submit" /> 
      </form>
      {this.state.data}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Api.js